import { render, staticRenderFns } from "./LightTabs.vue?vue&type=template&id=476134d8&scoped=true&"
import script from "./LightTabs.vue?vue&type=script&lang=js&"
export * from "./LightTabs.vue?vue&type=script&lang=js&"
import style0 from "./LightTabs.vue?vue&type=style&index=0&id=476134d8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476134d8",
  null
  
)

export default component.exports